import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import store from '../store'

const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    next()
    return
  }
  next('/home')
}

const ifAuthenticated = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    next()
    return
  }
  next('/')
}
//
// const ifAuthenticatedValitationUser = (to, from, next) => {
//   if (store.getters.isAuthenticated) {
//     next()
//     return
//   }
//   localStorage.setItem('pathValidationUser', to.path)
//   next('/')
// }

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'login',
    component: Login,
    beforeEnter: ifNotAuthenticated
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('@/views/Home.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/signup_tutor',
    name: 'signup_tutor',
    component: () => import('../views/signup_tutor')
  },
  {
    path: '/direct_registration',
    name: 'direct_registration',
    component: () => import('../views/direct_registration'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/signup_guest',
    name: 'signup_guest',
    component: () => import('../views/public/signup_guest')
  },
  {
    path: '/signup_tutor_success',
    name: 'signup_tutor_success',
    component: () => import('../views/public/signup_tutor_success')
  },
  {
    path: '/password_reset',
    name: 'password_reset',
    component: () => import('../views/public/password_reset')
  },
  {
    path: '/password_reset_done',
    name: 'password_reset_done',
    component: () => import('../views/public/password_reset_done')
  },
  {
    path: '/schools',
    name: 'schools',
    component: () => import('../views/super_admin/schools.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/managers',
    name: 'managers',
    component: () => import('../views/super_admin/managers.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/settings',
    name: 'settings',
    component: () => import('../views/general/settings.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/guards',
    name: 'guards',
    component: () => import('../views/admin/guards.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/tutors',
    name: 'tutors',
    component: () => import('../views/admin/tutors.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/new_records',
    name: 'new_records',
    component: () => import('../views/admin/new_records.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/notices',
    name: 'notices',
    component: () => import('../views/admin/notices.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/health',
    name: 'health2',
    component: () => import('../views/admin/health2.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/guardhouses',
    name: 'guardhouses',
    component: () => import('../views/admin/guard_houses.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/students',
    name: 'students',
    component: () => import('../views/admin/students.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/students2',
    name: 'students2',
    component: () => import('../views/admin/students2.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/absence',
    name: 'absence',
    component: () => import('../views/admin/absence.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/teachers',
    name: 'teachers',
    component: () => import('../views/admin/teachers.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/teachers2',
    name: 'teachers2',
    component: () => import('../views/admin/teachers2.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/classrooms',
    name: 'classrooms',
    component: () => import('../views/admin/classrooms.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/activities',
    name: 'activities',
    component: () => import('@/views/admin/activity.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/extracurricular_activity_teacher',
    name: 'extracurricular_activity_teacher',
    component: () => import('../views/admin/extracurricular_activity_teacher.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/extracurricular_activity_teacher2',
    name: 'extracurricular_activity_teacher2',
    component: () => import('../views/admin/extracurricular_activity_teacher2.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/extracurricular_activity_students',
    name: 'extracurricular_activity_students',
    component: () => import('../views/admin/extracurricular_activity_students.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/extracurricular_activity_students2',
    name: 'extracurricular_activity_students2',
    component: () => import('../views/admin/extracurricular_activity_students2.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/checkin_checkout',
    name: 'checkin_checkout',
    component: () => import('../views/guard/checkin_checkout.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/checkin_checkout_auto',
    name: 'checkin_checkout_auto',
    component: () => import('../views/guard/checkin_checkout_auto.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/invitation',
    name: 'invitation',
    component: () => import('../views/tutor/invitation'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/list',
    name: 'list',
    component: () => import('../views/teacher/list'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/transferred_students',
    name: 'transferred_students',
    component: () => import('../views/teacher/transferred_students'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/record_teacher',
    name: 'record_teacher',
    component: () => import('../views/teacher/record_teacher'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/teacher_extracurricular_activities',
    name: 'teacher_extracurricular_activities',
    component: () => import('../views/teacher/extracurricular_activities'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/attendance',
    name: 'attendance',
    component: () => import('../views/teacher/attendance'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/historical',
    name: 'historical',
    component: () => import('../views/common/historical'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/terms_conditions',
    name: 'terms_conditions',
    component: () => import('../views/public/terms_conditions')
  },
  {
    path: '/notice_privacy',
    name: 'notice_privacy',
    component: () => import('../views/public/notice_privacy')
  },
  {
    path: '/preregistration/:token',
    name: 'preregistration',
    component: () => import('../views/public/preregistration'),
  },
  {
    path: '/preregistration_success',
    name: 'preregistration_success',
    component: () => import('../views/public/preregistration_success')
  },
  {
    path: '/unconfirmed_guests',
    name: 'unconfirmed_guests',
    component: () => import('../views/tutor/unconfirmed_guests'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/tracking',
    name: 'tracking',
    component: () => import('../views/tutor/tracking'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/my_family',
    name: 'my_family',
    component: () => import('../views/tutor/my_family'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/ayuda_tutor',
    name: 'ayuda_tutor',
    component: () => import('../views/tutor/ayuda_tutor'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/qr/:qrcode',
    name: 'qr',
    component: () => import('../views/public/qr')
  },
  {
    path: '/guard_list',
    name: 'guard_list',
    component: () => import('../views/guard/guard_list'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/monitor',
    name: 'monitor',
    component: () => import('../views/guard/monitor'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/manual_check_in',
    name: 'manual_check_in',
    component: () => import('../views/guard/manual_check_in'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/unsigned_format',
    name: 'unsigned_format',
    component: () => import('../views/guard/unsigned_format'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/student_unsigned_format',
    name: 'student_unsigned_format',
    component: () => import('../views/guard/student_unsigned_format'),
    beforeEnter: ifAuthenticated
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
